import { showToast } from '../../components/Toast';
import {
  addPriorityOrderFail,
  addPriorityOrderSuccess,
  deletePriorityOrderFail,
  deletePriorityOrderSuccess,
  hideLoading,
  showLoading,
  updatePriorityOrderFail,
  updatePriorityOrderSuccess,
} from '../../store/priority/actions';
import { WsEvents } from '../events';
import { socket } from '../socket';

export function onAddPriorityOrder({ dispatch, newOrder }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.priority.ADD, newOrder, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(addPriorityOrderFail(res));
      return;
    }
    showToast('New Priority Order is added');
    dispatch(addPriorityOrderSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onUpdatePriorityOrder({ dispatch, data }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.priority.UPDATE, data, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(updatePriorityOrderFail(res));
      return;
    }
    showToast('Changes Successfully Applied');
    dispatch(updatePriorityOrderSuccess(res));
    dispatch(hideLoading(false));
  }
}

export function onDeletePriorityOrder({ dispatch, order }) {
  dispatch(showLoading(true));
  socket.emit(WsEvents.priority.DELETE, order, callback);
  function callback(res) {
    if ('error' in res) {
      dispatch(hideLoading(true));
      dispatch(deletePriorityOrderFail(res));
      return;
    }
    showToast('Order is deleted from the system');
    dispatch(deletePriorityOrderSuccess(res));
    dispatch(hideLoading(false));
  }
}
